import {
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react'
import { Controller, UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { FormItem } from 'components'
// import Validation from './components/Validation'

type ValidationsProps = {
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function CharactersLimitValidator({ formMethods }: ValidationsProps) {
  return (
    <FormItem label="Máximo de caractéres">
      <Controller
        name="validation.max"
        control={formMethods.control}
        render={({ field }) => (
          <NumberInput
            {...field}
            value={field.value ?? 0}
            onChange={(valueString) => field.onChange(Number(valueString || 0))}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        )}
      />
    </FormItem>
  )
}
